__turbopack_context__.v({
  "className": "noto_sans_688e94e1-module__-SApsq__className",
  "variable": "noto_sans_688e94e1-module__-SApsq__variable",
});
